import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import '../styles/hamburgers.min.css';

import ButtonLink from './global/button-link';

const MobileNavStyle = styled.div`
	display: none;
	@media all and (max-width: 1100px) {
		display: block;
		.hamburger {
			z-index: 11;
			position: absolute;
			right: 2.5rem;
			top: 1.75rem;

			&.is-active:hover,
			&:hover {
				opacity: 1;
			}

			.hamburger-inner {
				&::before,
				&::after,
				& {
					background-color: #fff;
				}
			}

			&.is-active {
				position: fixed;
				.hamburger-inner {
					&::before,
					&::after,
					& {
						background-color: #fff;
					}
				}
			}
		}

		nav.pages {
			position: fixed;
			z-index: 10;
			right: -400px;
			transition: right 0.3s;
			top: 0;
			width: 400px;
			border-bottom-right-radius: 40px;
			border-bottom-left-radius: 40px;
			background-color: ${(p) => p.theme.color.darkPurple};
			background-image: url(/img/mobile-purple-blob.svg);
			background-position: -4rem 6rem;
			background-size: 100% auto;
			background-repeat: no-repeat;
			padding: 1.5rem 3rem 3rem;

			ul {
				height: auto;

				li,
				li.show-mobile {
					display: block;
					line-height: 3rem;

					&.menu-logo {
						width: 170px;
						margin-bottom: 4rem;
					}

					&:not(.button-link) a {
						font-weight: 700;
						font-size: 1.5rem;
						margin: 1rem 0;
						letter-spacing: 0.3rem;
					}
					a {
						position: relative;
						&::after {
							content: '';
							background-color: #fff;
							transition: 0.3s width;
							width: 0;
							height: 2px;
							position: absolute;
							bottom: 0;
							left: 0;
						}
						&:hover::after {
							width: 98%;
						}
						/* Hide on mobile */
						@media (hover: none) {
							&::after {
								display: none;
							}
						}
					}
					&.button-link a {
						border-radius: 1.5rem;
						padding: 0.25rem 1.75rem;
						line-height: 2.5rem;
						font-size: 1.5rem;
						margin-top: 1rem;
						&::after {
							display: none;
						}
					}
				}
			}
		}
		&.is-active nav.pages {
			right: 0;
			.hamburger {
				position: fixed;
			}
		}
	}
	@media all and (max-width: 550px) {
		.hamburger {
			right: 1rem;
			top: 1rem;
		}
	}
	@media all and (max-width: 450px) {
		button {
			.hamburger-box {
				width: 30px;

				.hamburger-inner {
					width: 30px;

					&::before,
					&::after {
						width: 30px;
					}
				}
			}
		}
		nav.pages {
			width: 100%;
			right: -100%;
		}
	}
`;

const MobileNav = ({ setOpen, isOpen }) => (
	<MobileNavStyle className={isOpen ? 'is-active' : ''}>
		<button
			type="button"
			className={
				isOpen
					? 'hamburger hamburger--spin is-active'
					: 'hamburger hamburger--spin'
			}
			onClick={() => setOpen(!isOpen)}
			aria-label="burger menu"
		>
			<span className="hamburger-box">
				<span className="hamburger-inner" />
			</span>
		</button>
		<nav className="pages">
			<ul>
				<li className="show-mobile menu-logo">
					<Link onClick={() => setOpen(false)} to="/">
						<img src="/img/StartTalking_Logo.svg" alt="start talking logo" />
					</Link>
				</li>
				<li>
					<Link onClick={() => setOpen(false)} to="/about/">
						ABOUT
					</Link>
				</li>
				<li>
					<Link onClick={() => setOpen(false)} to="/education/">
						EDUCATION
					</Link>
				</li>
				<li>
					<Link onClick={() => setOpen(false)} to="/stories/">
						STORIES
					</Link>
				</li>
				<li>
					<Link onClick={() => setOpen(false)} to="/events/">
						EVENTS
					</Link>
				</li>
				<li>
					<Link onClick={() => setOpen(false)} to="/contact/">
						CONTACT
					</Link>
				</li>
				<li className="button-link">
					<ButtonLink
						className="menu-donate"
						onClick={() => setOpen(false)}
						to="/donate/"
					>
						DONATE
					</ButtonLink>
				</li>
			</ul>
		</nav>
	</MobileNavStyle>
);

export default MobileNav;
